import { render, staticRenderFns } from "./ProcessInvoices.vue?vue&type=template&id=4e283e7f"
import script from "./ProcessInvoices.vue?vue&type=script&lang=js"
export * from "./ProcessInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports